type OrderSide = 'buy' | 'sell';

export function validatePrice(
  price: number,
  fairPrice: number,
  previousDayClosingPrice: number,
  orderSide: OrderSide
): boolean {
  if (price < 200 && fairPrice < 200 && previousDayClosingPrice < 200) {
    return true;
  } else {
    if (orderSide === 'buy') {
      const differencePrice = Math.max(
        fairPrice * 1.5,
        previousDayClosingPrice * 1.5
      );

      return !(price > differencePrice);
    } else if (orderSide === 'sell') {
      const differencePrice = Math.min(
        fairPrice * 0.5,
        previousDayClosingPrice * 0.5
      );

      return !(price < differencePrice);
    }
  }

  return true;
}
